export const copy = {
	props: {
		buttonText: {
			type: String,
			default: 'Clone',
		},
		toolTipText: {
			type: String,
			default: 'Click to copy.',
		},
		copiedTooltipText: {
			type: String,
			default: 'Copied!',
		},
	},
	data() {
		return {
			copied: false,
			showCopyTooltip: false,
		};
	},
	computed: {
		tooltipText() {
			return this.copied ? this.copiedTooltipText : this.toolTipText;
		},
	},
	methods: {
		copyValue() {
			this.showCopyTooltip = false;
			this.$copyText(this.$slots.default[0].text.trim())
				.then(() => (this.copied = true))
				.then(() =>
					setTimeout(() => {
						this.showCopyTooltip = false;
						setTimeout(() => {
							this.copied = false;
						}, 0);
					}, 1000)
				)
				.then(() => (this.showCopyTooltip = true));
		},
	},
};
